import React from 'react';
import '@ui5/webcomponents-fiori/dist/illustrations/UnableToLoad.js';
import { Button, IllustratedMessage, IllustratedMessagePropTypes } from '@ui5/webcomponents-react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './ErrorPage.jss';

import ButtonDesign from '@ui5/webcomponents/dist/types/ButtonDesign.js';
import IllustrationMessageType from '@ui5/webcomponents-fiori/dist/types/IllustrationMessageType.js';

export interface ErrorPageProps extends IllustratedMessagePropTypes {
  withReturnToMainPageButton?: boolean;
  messageType: IllustrationMessageType;
  titleText: string;
  subtitleText: string;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({
  withReturnToMainPageButton = false,
  messageType,
  titleText,
  subtitleText,
  ...props
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const onReturnToMainPage = () => {
    location.assign('/queries');
  };

  return (
    <IllustratedMessage
      {...props}
      name={messageType}
      titleText={titleText}
      subtitleText={subtitleText}
      className={classes.illustratedMessage}
    >
      {withReturnToMainPageButton && (
        <Button design={ButtonDesign.Emphasized} onClick={onReturnToMainPage}>
          {t('return-home-screen')}
        </Button>
      )}
    </IllustratedMessage>
  );
};
